import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import { accountLogin } from '../../graphql/mutations/account';
import LoginForm from '../../components/auth/EmailLoginForm';
import {
  loginRequest,
  loginSuccess,
  loginFailure,
} from '../../actions/auth-actions';

const withLoginMutation = graphql(accountLogin, {
  props: ({ mutate }) => ({
    accountLoginMutation: (email, password) =>
      mutate({
        variables: {
          input: { email, password },
        },
      }),
  }),
});

const mapStateToProps = ({ auth }) => ({
  loading: auth.loading,
  error: auth.error,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  login: async (email, password) => {
    dispatch(loginRequest());

    try {
      await ownProps.accountLoginMutation(email, password);
      dispatch(loginSuccess());

      // `?next=` query comes from RequireAuth where
      // it is set on the server via `staticContext`.
      const parsed = qs.parse(ownProps.location.search);
      ownProps.history.push(parsed.next || '/app');
    } catch (error) {
      dispatch(loginFailure('Wrong email or password.'));
    }
  },
});

export default compose(
  withLoginMutation,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(LoginForm);
